"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useLocalStorage = () => {
    const { localStorage } = (0, react_1.useContext)(context_1.EnrichContext);
    return localStorage;
};
exports.useLocalStorage = useLocalStorage;
exports.default = exports.useLocalStorage;
